var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.819,
    height: 18.774,
    viewBox: "0 0 130.819 18.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-617.33 -677.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Forma_1_copy",
    "data-name": "Forma 1 copy",
    d: "M617.33,696.19V685.43h3.5v10.76Zm12.172-.008v-6.844c-1.118-2.7-3.766.978-3.766.978v5.866h-3.5V685.426h3.5v2.057a4.872,4.872,0,0,1,3.766-2.057,3.174,3.174,0,0,1,.629.064l.141.027c.04.011.075.024.112.036a3.49,3.49,0,0,1,2.622,3.371v7.258ZM617.34,682.25a1.71,1.71,0,1,1,1.71,1.709A1.71,1.71,0,0,1,617.34,682.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Forma_1_copy_2",
    "data-name": "Forma 1 copy 2",
    d: "M671.13,683.806a7.488,7.488,0,0,1-2.071.571,3.592,3.592,0,0,0,1.582-2,7.167,7.167,0,0,1-2.28.874,3.591,3.591,0,0,0-6.219,2.471,3.743,3.743,0,0,0,.083.824,10.161,10.161,0,0,1-7.411-3.78,3.626,3.626,0,0,0,1.1,4.83,3.537,3.537,0,0,1-1.624-.444v.04a3.626,3.626,0,0,0,2.88,3.55,3.547,3.547,0,0,1-.943.119,3.151,3.151,0,0,1-.681-.061,3.632,3.632,0,0,0,3.359,2.517,7.2,7.2,0,0,1-4.458,1.541,6.763,6.763,0,0,1-.861-.049,10.081,10.081,0,0,0,5.515,1.621,10.19,10.19,0,0,0,10.233-10.283c0-.161-.005-.314-.013-.467A7.193,7.193,0,0,0,671.13,683.806Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Forma_1_copy_3",
    "data-name": "Forma 1 copy 3",
    d: "M704.655,677.889l-2.444,0a4.282,4.282,0,0,0-4.519,4.62v2.13h-2.457a.384.384,0,0,0-.384.383V688.1a.384.384,0,0,0,.384.383h2.457v7.788a.383.383,0,0,0,.384.383h3.205a.383.383,0,0,0,.384-.383v-7.788h2.872a.383.383,0,0,0,.384-.383v-3.086a.384.384,0,0,0-.385-.383h-2.873v-1.805c0-.868.207-1.309,1.342-1.309h1.646a.383.383,0,0,0,.384-.383v-2.866A.383.383,0,0,0,704.655,677.889Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Forma_1_copy_4",
    "data-name": "Forma 1 copy 4",
    d: "M736.3,695.877a5.384,5.384,0,0,1-5.387-5.378v-6.455a5.383,5.383,0,0,1,5.387-5.377h6.466a5.383,5.383,0,0,1,5.387,5.377V690.5a5.384,5.384,0,0,1-5.387,5.378Zm-3.771-11.833V690.5a3.771,3.771,0,0,0,3.771,3.764h6.466a3.771,3.771,0,0,0,3.771-3.764v-6.455a3.772,3.772,0,0,0-3.771-3.764H736.3A3.772,3.772,0,0,0,732.525,684.044Zm2.694,3.227a4.31,4.31,0,1,1,4.31,4.3A4.306,4.306,0,0,1,735.219,687.272Zm1.616,0a2.694,2.694,0,1,0,2.694-2.688A2.7,2.7,0,0,0,736.835,687.272Zm6.755-4.622a.57.57,0,1,1,.57.57A.57.57,0,0,1,743.59,682.65Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconImage);
export default __webpack_public_path__ + "static/media/social_icon_image.d9eaf4f2ffdfe9b8c416a2263c718ed4.svg";
export { ForwardRef as ReactComponent };